import arrondiResult from '@/services/general/arrondiCalcul';

export function calculPrixTotalReseauTempo(produit) {
  const tarifNet = produit.extensionOpportunite.tarifNet ?
    produit.extensionOpportunite.tarifNet : 0;
  const taxeMunicipale = produit.extensionOpportunite.taxeMunicipale ?
    produit.extensionOpportunite.taxeMunicipale : 0;
  const tarifDePose = produit.extensionOpportunite.tarifDePose ?
    produit.extensionOpportunite.tarifDePose : 0;
  const tarifImpression = produit.extensionOpportunite.tarifImpression ?
    produit.extensionOpportunite.tarifImpression : 0;
  return arrondiResult(tarifNet
    + taxeMunicipale
    + tarifDePose
    + tarifImpression);
}

export function calculPrixTotalVenteLc(produit) {
  const tarifNet = produit.extensionOpportunite.tarifNet ?
    produit.extensionOpportunite.tarifNet : 0;
  const taxeMunicipale = produit.extensionOpportunite.taxeMunicipale ?
    produit.extensionOpportunite.taxeMunicipale : 0;
  const tarifDePose = produit.extensionOpportunite.tarifDePose ?
    produit.extensionOpportunite.tarifDePose : 0;
  const fraisTechnique = produit.extensionOpportunite.fraisTechnique ?
    produit.extensionOpportunite.fraisTechnique : 0;
  return arrondiResult(tarifNet
    + taxeMunicipale
    + tarifDePose
    + fraisTechnique);
}

function prixRemiseVenteNumerique(produit) {
  if (produit.extensionOpportunite.typeDeRemise === 0) {
    return produit.extensionOpportunite.tarifHt * produit.extensionOpportunite.quantite
      * produit.extensionOpportunite.remise / 100;
  }
  return produit.extensionOpportunite.remise;
}

export function calculPrixTotalVenteNumerique(produit) {
  const prixRemise = prixRemiseVenteNumerique(produit);
  const quantite = produit.extensionOpportunite.quantite;
  const tarifHt = produit.extensionOpportunite.tarifHt ?
    produit.extensionOpportunite.tarifHt : 0;
  const taxeMunicipale = produit.extensionOpportunite.taxeMunicipale ?
    produit.extensionOpportunite.taxeMunicipale : 0;
  const fraisAdserving = produit.extensionOpportunite.fraisAdserving ?
    produit.extensionOpportunite.fraisAdserving : 0;
  return arrondiResult(tarifHt * quantite
    - prixRemise
    + taxeMunicipale
    + fraisAdserving);
}

export function calculPrixTotalReseauLc(produit) {
  const tarifNet = produit.extensionOpportunite.tarifNet ?
    produit.extensionOpportunite.tarifNet : 0;
  const taxeMunicipale = produit.extensionOpportunite.taxeMunicipale ?
    produit.extensionOpportunite.taxeMunicipale : 0;
  const tarifDePose = produit.extensionOpportunite.tarifDePose ?
    produit.extensionOpportunite.tarifDePose : 0;
  const fraisTechnique = produit.extensionOpportunite.fraisTechnique ?
    produit.extensionOpportunite.fraisTechnique : 0;
  return arrondiResult(tarifNet
    + taxeMunicipale
    + tarifDePose
    + fraisTechnique);
}

export function calculPrixTotalReseauNumerique(produit) {
  const taxeMunicipale = produit.extensionOpportunite.taxeMunicipale ?
    produit.extensionOpportunite.taxeMunicipale : 0;
  const fraisAdserving = produit.extensionOpportunite.fraisAdserving ?
    parseInt(produit.extensionOpportunite.fraisAdserving, 10) : 0;
  const tarifNet = produit.extensionOpportunite.tarifNet ?
    produit.extensionOpportunite.tarifNet : 0;
  return arrondiResult(tarifNet
    + taxeMunicipale
    + fraisAdserving);
}

export function calculPrixTotalReseauPersonnalise(produit) {
  const tarifNet = produit.tarifNet ? produit.tarifNet : 0;
  const taxeMunicipale = produit.taxeMunicipale ? produit.taxeMunicipale : 0;
  const tarifDePose = produit.tarifDePose ? produit.tarifDePose : 0;
  const tarifImpression = produit.tarifImpression ? produit.tarifImpression : 0;
  return arrondiResult(tarifNet
    + taxeMunicipale
    + tarifDePose
    + tarifImpression);
}



// WEBPACK FOOTER //
// ./src/services/panier/calculPrixTotal.js